import { LoadingButton } from '@mui/lab';
import { Alert, Box, Snackbar, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { api } from 'src/Api';
import Page from 'src/components/Page';

const Help = () => {
  const [email, setemail] = useState('');
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const SendLink = () => {
    const token = localStorage.getItem('token');
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    var formdata = new FormData();
    formdata.append('email', email);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow'
    };
    fetch(api.share_link, requestOptions)
      .then((response) => {
        console.log('response', response);
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json().then((error) => {
            console.log('result =====>>>>>credentail', error);
            setalert({ visible: true, message: error.error });
          });
        }
      })
      .then((result) => {
        if (result.success == true) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
        }
      })
      .catch((error) => {
        setalert({ visible: true, message: error.error });
      })
      .finally(() => {
        setloading(false);
      });
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Page title={`Help | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Box
        sx={{
          ml: 2
        }}
      >
        <Typography variant="h4" sx={{ color: '#f90001' }}>
          Help
        </Typography>
        {/* <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', // Center align the content horizontally if desired
            gap: 1, // Adjust gap as needed to control the spacing
            //   width: '100%', // Optional for full width
            //   maxWidth: '400px', // Optional max width for responsive layout
            //   margin: '0 auto'
            mt: 5
          }}
        >
          <TextField
            style={{ width: '50%' }}
            // fullWidth
            label="Email"
            onChange={(e) => setemail(e.target.value)}
            type="email"
            value={email}
            variant="outlined"
            className="custom-textfield"
          />
          <LoadingButton
            style={{ marginTop: 20, width: '50%' }}
            // fullWidth
            size="large"
            variant="contained"
            loading={loading}
            onClick={SendLink}
          >
            Send
          </LoadingButton>
        </Box> */}

        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            mt: 25
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#000'
              // marginBottom: 1
            }}
          >
            If you have any issues, please contact us at:
          </Typography>
          <Typography
            component="a"
            href="mailto:info@samtwireless.com"
            sx={{
              fontSize: '14px',
              color: '#f90001',
              textDecoration: 'underline',
              cursor: 'pointer'
            }}
          >
            info@samtwireless.com
          </Typography>
        </Box>
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
        {/* {alert.visible && (
        <Alert
          onClose={() => {
            setalert({ visible: false, message: '' });
          }}
          severity="error"
          style={{ fontSize: 12, marginBottom: 20 }}
        >
          {alert.message}
        </Alert>
      )} */}
      </Box>
    </Page>
  );
};

export default Help;
